/**
 * Currency mapping data for all countries and their currency codes
 * Synchronized with backend currency_mappings.json
 */

export const currencyMapping = {
  Afghanistan: { code: 'AFN', symbol: '؋' },
  Albania: { code: 'ALL', symbol: 'L' },
  Algeria: { code: 'DZD', symbol: 'دج' },
  Andorra: { code: 'EUR', symbol: '€' },
  Angola: { code: 'AOA', symbol: 'Kz' },
  'Antigua and Barbuda': { code: 'XCD', symbol: '$' },
  Argentina: { code: 'ARS', symbol: '$' },
  Armenia: { code: 'AMD', symbol: '֏' },
  Australia: { code: 'AUD', symbol: '$' },
  Austria: { code: 'EUR', symbol: '€' },
  Azerbaijan: { code: 'AZN', symbol: '₼' },
  Bahamas: { code: 'BSD', symbol: '$' },
  Bahrain: { code: 'BHD', symbol: '.د.ب' },
  Bangladesh: { code: 'BDT', symbol: '৳' },
  Barbados: { code: 'BBD', symbol: '$' },
  Belarus: { code: 'BYN', symbol: 'Br' },
  Belgium: { code: 'EUR', symbol: '€' },
  Belize: { code: 'BZD', symbol: '$' },
  Benin: { code: 'XOF', symbol: 'CFA' },
  Bhutan: { code: 'BTN', symbol: 'Nu.' },
  Bolivia: { code: 'BOB', symbol: 'Bs.' },
  'Bosnia and Herzegovina': { code: 'BAM', symbol: 'KM' },
  Botswana: { code: 'BWP', symbol: 'P' },
  Brazil: { code: 'BRL', symbol: 'R$' },
  Brunei: { code: 'BND', symbol: '$' },
  Bulgaria: { code: 'BGN', symbol: 'лв' },
  'Burkina Faso': { code: 'XOF', symbol: 'CFA' },
  Burundi: { code: 'BIF', symbol: 'FBu' },
  Cambodia: { code: 'KHR', symbol: '៛' },
  Cameroon: { code: 'XAF', symbol: 'FCFA' },
  Canada: { code: 'CAD', symbol: '$' },
  Chile: { code: 'CLP', symbol: '$' },
  China: { code: 'CNY', symbol: '¥' },
  Colombia: { code: 'COP', symbol: '$' },
  'Congo (Democratic Republic)': { code: 'CDF', symbol: 'FC' },
  'Costa Rica': { code: 'CRC', symbol: '₡' },
  Croatia: { code: 'HRK', symbol: 'kn' },
  Cuba: { code: 'CUP', symbol: '$' },
  'Czech Republic': { code: 'CZK', symbol: 'Kč' },
  Denmark: { code: 'DKK', symbol: 'kr' },
  'Dominican Republic': { code: 'DOP', symbol: 'RD$' },
  Ecuador: { code: 'USD', symbol: '$' },
  Egypt: { code: 'EGP', symbol: '£' },
  'El Salvador': { code: 'SVC', symbol: '$' },
  Eritrea: { code: 'ERN', symbol: 'Nfk' },
  Estonia: { code: 'EUR', symbol: '€' },
  Eswatini: { code: 'SZL', symbol: 'E' },
  Ethiopia: { code: 'ETB', symbol: 'Br' },
  Eurozone: { code: 'EUR', symbol: '€' },
  Fiji: { code: 'FJD', symbol: '$' },
  Finland: { code: 'EUR', symbol: '€' },
  France: { code: 'EUR', symbol: '€' },
  Gabon: { code: 'XAF', symbol: 'FCFA' },
  Gambia: { code: 'GMD', symbol: 'D' },
  Georgia: { code: 'GEL', symbol: '₾' },
  Germany: { code: 'EUR', symbol: '€' },
  Ghana: { code: 'GHS', symbol: '₵' },
  Greece: { code: 'EUR', symbol: '€' },
  Guatemala: { code: 'GTQ', symbol: 'Q' },
  Guinea: { code: 'GNF', symbol: 'FG' },
  Haiti: { code: 'HTG', symbol: 'G' },
  Honduras: { code: 'HNL', symbol: 'L' },
  Hungary: { code: 'HUF', symbol: 'Ft' },
  Iceland: { code: 'ISK', symbol: 'kr' },
  India: { code: 'INR', symbol: '₹' },
  Indonesia: { code: 'IDR', symbol: 'Rp' },
  Iran: { code: 'IRR', symbol: '﷼' },
  Iraq: { code: 'IQD', symbol: 'ع.د' },
  Ireland: { code: 'EUR', symbol: '€' },
  Israel: { code: 'ILS', symbol: '₪' },
  Italy: { code: 'EUR', symbol: '€' },
  Jamaica: { code: 'JMD', symbol: 'J$' },
  Japan: { code: 'JPY', symbol: '¥' },
  Jordan: { code: 'JOD', symbol: 'د.ا' },
  Kazakhstan: { code: 'KZT', symbol: '₸' },
  Kenya: { code: 'KES', symbol: 'KSh' },
  Kuwait: { code: 'KWD', symbol: 'د.ك' },
  Malaysia: { code: 'MYR', symbol: 'RM' },
  Mexico: { code: 'MXN', symbol: '$' },
  Netherlands: { code: 'EUR', symbol: '€' },
  'New Zealand': { code: 'NZD', symbol: '$' },
  Nigeria: { code: 'NGN', symbol: '₦' },
  Norway: { code: 'NOK', symbol: 'kr' },
  Pakistan: { code: 'PKR', symbol: '₨' },
  Philippines: { code: 'PHP', symbol: '₱' },
  Russia: { code: 'RUB', symbol: '₽' },
  'Saudi Arabia': { code: 'SAR', symbol: '﷼' },
  'South Africa': { code: 'ZAR', symbol: 'R' },
  Sweden: { code: 'SEK', symbol: 'kr' },
  Switzerland: { code: 'CHF', symbol: 'CHF' },
  Turkey: { code: 'TRY', symbol: '₺' },
  'United Kingdom': { code: 'GBP', symbol: '£' },
  'United States': { code: 'USD', symbol: '$' },
  Vietnam: { code: 'VND', symbol: '₫' }
};

/**
 * Get currency code for a given country
 * @param {string} country - The country name
 * @returns {string} The currency code or USD as fallback
 */
export const getCurrencyCode = (currencyData) => {
  if (typeof currencyData === 'string') return currencyData;
  return currencyData?.code || 'USD';
};

export const getCurrencySymbol = (currencyData) => {
  if (typeof currencyData === 'string') {
    // Find symbol from code
    const entry = Object.values(currencyMapping).find(
      (c) => c.code === currencyData
    );
    return entry?.symbol || currencyData;
  }
  return currencyData?.symbol || '$';
};

// Format price with currency
export const formatPrice = (price, currency) => {
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${price}`;
};
export const getAllCurrencies = () => {
  return Object.entries(currencyMapping).map(([country, code]) => ({
    country,
    code
  }));
};
